import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      height: 100%;
    `,
    prefixWrap: css`
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    `,
    btn: css`
      width: 100%;
      border-radius: 30px;
      height: 50px !important;
    `,
    processWrap: css`
      height: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `,
    verifyBox: css`
      width: 60px;
      height: 56px;
      border: 1px solid #f3f2f6;
      border-radius: 4px;
    `,
    processText: css`
      margin-top: 10px;
    `,
    footer: css`
      margin-top: 100px;
      padding-bottom: 40px;
    `,
    alert: css`
      margin-bottom: 10px;
    `,
      imageItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxSizing: "border-box",
        marginBottom: "20px",
      },
      image: {
        width: "60px",
        height: "60px",
        borderRadius: "8px",
      },
      removeIcon: {
        fontSize: "20px",
        cursor: "pointer",
        "&:hover": { color: "red" },
      },
      warp: css`
        margin-top: 10px;
      `
  };
});
